module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Player', {
    ref: "Player",
    attrs: {
      "subtitles": _vm.data,
      "playAt": _vm.sentIdx,
      "url": _vm.mediaUrl,
      "slowAudioUrl": _vm.config.slowAudioUrl,
      "control": _vm.control
    },
    on: {
      "video": _vm.updateVideoState
    }
  }), _vm._v(" "), _c('div', {
    ref: "text",
    staticClass: "panel",
    class: {
      'half-height': (_vm.mode !== 'default'),
      'phrase': (_vm.mode === 'phrases')
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.mode !== 'dictionary') ? _c('Sentences', {
    attrs: {
      "texts": _vm.texts,
      "currentTime": _vm.video.currentTime,
      "lang": ['en_us'],
      "slow": _vm.video.slow,
      "highlight": _vm.highlight
    },
    on: {
      "word": _vm.findDics,
      "selectSentId": _vm.playSingle
    }
  }) : _c('Sentences', {
    attrs: {
      "texts": _vm.texts,
      "currentTime": _vm.video.currentTime,
      "slow": _vm.video.slow,
      "dict": true
    },
    on: {
      "word": _vm.findDics
    }
  })], 1), _vm._v(" "), (_vm.mode === 'translate') ? _c('div', {
    ref: "translate",
    staticClass: "panel half-height mt-2"
  }, [_c('Sentences', {
    attrs: {
      "texts": _vm.texts,
      "lang": ['zh_tw'],
      "slow": _vm.video.slow,
      "currentTime": _vm.video.currentTime
    },
    on: {
      "selectSentId": _vm.playSingle
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'dictionary') ? _c('div', {
    ref: "dictionary",
    staticClass: "panel half-height mt-2"
  }, [(_vm.dicData === null) ? _c('div', {
    staticClass: "p-3"
  }, [_vm._v("已開啟字典功能，請點選想查詢的單字")]) : _c('div', {
    staticClass: "p-3"
  }, [_c('div', [_c('span', {
    staticClass: "clickable dict-speak",
    on: {
      "click": function($event) {
        return _vm.dictSpeak(_vm.dicData.key)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-volume-up"
  }), _vm._v(" " + _vm._s(_vm.dicData.key) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "pron"
  }, [_vm._v(_vm._s(_vm.dicData.phon))]), _vm._v(" "), _c('p', {
    staticClass: "pre"
  }, [_vm._v(_vm._s(_vm.dicData.expl))]), _vm._v(" "), _vm._l((_vm.dicData.extend), function(extend, extendIndex) {
    return (_vm.dicData.extend && _vm.dicData.extend.length > 0) ? _c('div', {
      key: extendIndex
    }, [_c('p', [_c('span', {
      staticClass: "clickable dict-speak",
      on: {
        "click": function($event) {
          return _vm.dictSpeak(extend.key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-volume-up"
    }), _vm._v(" " + _vm._s(extend.key) + "\n          ")])]), _vm._v(" "), _c('p', {
      staticClass: "pron"
    }, [_vm._v(_vm._s(extend.phon))]), _vm._v(" "), _c('p', {
      staticClass: "pre"
    }, [_vm._v(_vm._s(extend.expl))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.mode === 'vocabularies') ? _c('div', {
    ref: "vocabularies",
    staticClass: "panel half-height mt-2"
  }, [_c('Vocabularies', {
    attrs: {
      "data": _vm.vocabularies
    },
    on: {
      "sound": _vm.updateUrl,
      "audio": _vm.playAudioFile
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'phrases') ? _c('div', {
    ref: "phrases",
    staticClass: "panel half-height mt-2"
  }, [_c('Phrases', {
    attrs: {
      "data": _vm.phrases
    },
    on: {
      "sound": _vm.updateUrl,
      "audio": _vm.playAudioFile
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('button', {
    class: {
      'btn': true, 'highlight': _vm.mode === 'translate'
    },
    attrs: {
      "alt": "翻譯"
    },
    on: {
      "click": function($event) {
        return _vm.switchMode('translate')
      }
    }
  }, [(_vm.mode !== 'translate') ? _c('img', {
    attrs: {
      "src": require("../assets/images/btn_video_ch_off.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/btn_video_ch_on.png")
    }
  })]), _vm._v(" "), (_vm.dictionary.length > 0 && _vm.texts && _vm.texts[0].dicInfos) ? _c('button', {
    class: {
      'btn': true, 'highlight': _vm.mode === 'dictionary'
    },
    attrs: {
      "alt": "字典"
    },
    on: {
      "click": function($event) {
        return _vm.switchMode('dictionary')
      }
    }
  }, [(_vm.mode !== 'dictionary') ? _c('img', {
    attrs: {
      "src": require("../assets/images/text_dictionary_off.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/text_dictionary_on.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.vocabularies && _vm.vocabularies.length > 0) ? _c('button', {
    class: {
      'btn': true, 'highlight': _vm.mode === 'vocabularies'
    },
    attrs: {
      "alt": "單字"
    },
    on: {
      "click": function($event) {
        return _vm.switchMode('vocabularies')
      }
    }
  }, [(_vm.mode !== 'vocabularies') ? _c('img', {
    attrs: {
      "src": require("../assets/images/text_word_off.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/text_word_on.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.phrases && _vm.phrases.length > 0) ? _c('button', {
    class: {
      'btn': true, 'highlight': _vm.mode === 'phrases'
    },
    attrs: {
      "alt": "重點"
    },
    on: {
      "click": function($event) {
        return _vm.switchMode('phrases')
      }
    }
  }, [(_vm.mode !== 'phrases') ? _c('img', {
    attrs: {
      "src": require("../assets/images/text_key_off.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/text_key_on.png")
    }
  })]) : _vm._e(), _vm._v(" "), (false) ? _c('popper', {
    ref: "downloadPopper",
    attrs: {
      "trigger": "click",
      "options": {
        placement: 'bottom'
      }
    }
  }, [_c('div', {
    staticClass: "popper"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$refs.downloadPopper.doClose() || _vm.exportSents()
      }
    }
  }, [_vm._v("\n              課文\n          ")]), _vm._v(" "), (_vm.phrases && _vm.phrases.length > 0) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$refs.downloadPopper.doClose() || _vm.exportPhrase()
      }
    }
  }, [_vm._v("\n              片語\n          ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/text_download.png")
    }
  })])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cd1aaba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Texts.vue
// module id = 767
// module chunks = 3